document.addEventListener(
	'DOMContentLoaded',
	function () {
		const openNav = document.querySelector('.header__checkbox');
		const header = document.querySelector('.header');
		const navbar = document.querySelector('.header__nav');
		const openSearch = document.querySelector('.header__search__open');
		const searchBarM = document.querySelector('.header__search.mobile');
		const searchBarD = document.querySelector('.header__search.desktop');
		const closeSearchBarM = document.querySelector('.header__search.mobile .header__search__close');
		const closeSearchBarD = document.querySelector('.header__search.desktop .header__search__close');
		const headerCta = document.querySelector('.header .button-block');
		const hasSubMenu = document.querySelectorAll('.header .menu-item-has-children > a');
		const bodyPage = document.body;
		const arrow =
			'<svg width="12" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.99922 3.98923L2.00755 -0.00244141L0.824219 1.17256L5.40755 5.75589C5.48502 5.834 5.57719 5.89599 5.67874 5.9383C5.78029 5.98061 5.88921 6.00239 5.99922 6.00239C6.10923 6.00239 6.21815 5.98061 6.3197 5.9383C6.42125 5.89599 6.51342 5.834 6.59089 5.75589L11.1742 1.17256L9.99089 -0.00244141L5.99922 3.98923Z" fill="white"/></svg>';

		const getWindowWidth = () => window.innerWidth;

		openNav.addEventListener('click', () => {
			navbar.classList.toggle('active');
			header.classList.toggle('active');
			const isMenuActive = navbar.classList.contains('active');
			bodyPage.style.overflow = isMenuActive ? 'hidden' : '';
		});

		openSearch.addEventListener('click', () => {
			if (getWindowWidth() < 1024) {
				searchBarM.classList.toggle('active');
				navbar.classList.remove('active');
				openNav.checked = false;
			} else {
				searchBarD.classList.toggle('active');
				openSearch.style.opacity = 0;
				headerCta.style.opacity = 0;
			}

			openNav.checked = false;
			navbar.classList.remove('active');
			header.classList.remove('active');
			bodyPage.style.overflow = '';
		});

		closeSearchBarM.addEventListener('click', () => {
			searchBarM.classList.remove('active');
		});

		closeSearchBarD.addEventListener('click', () => {
			searchBarD.classList.remove('active');
			openSearch.style.opacity = 1;
			headerCta.style.opacity = 1;
		});

		// Add arrow and remove href if menu item has submenu

		function setupMenuItem(menuItem) {
			const titleMenu = menuItem.textContent;
			menuItem.innerHTML = titleMenu + arrow;
			menuItem.removeAttribute('href');

			let subMenu = menuItem.nextElementSibling;

			// Toggle active state onClick
			menuItem.addEventListener('click', function () {
				subMenu.classList.toggle('active');
				menuItem.classList.toggle('active');
			});

			// Update active states based on window width
			function updateActiveState() {
				if (getWindowWidth() > 1024) {
					subMenu.classList.add('active');
					menuItem.classList.add('active');
				} else {
					subMenu.classList.remove('active');
					menuItem.classList.remove('active');
				}
			}

			// Attach and handle resize event
			window.addEventListener('resize', updateActiveState);

			updateActiveState();
		}

		// Apply setup to each menu item
		hasSubMenu.forEach(setupMenuItem);
	},
	false,
);
